import {NUMBER} from '@drivesally/sally-fw/lib/inputTypes';

// attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

// types
import fourDecimalAmount from '@drivesally/sally-fw/lib/type/types/fourDecimalAmount.type';
import formattedFourDecimalNumber from '@drivesally/sally-fw/lib/type/types/formattedFourDecimalNumber.type';
import number from '@drivesally/sally-fw/lib/type/types/number.type';

export default attribute({
  type: NUMBER,
  attribute: 'tax_rate',
  display: fourDecimalAmount,
  input: formattedFourDecimalNumber,
  api: number,
  label: {
    default: 'Tax Rate',
    short: 'Tax Rate',
  },
});
